<template>
  <div class="list-reviews reviews" :class="{'list-loaded': statusLoaded}">
    <div class="reviews__list">
      <div v-if="listReviews && listReviews.length !== 0">
        <Review v-for="(item, index) in listReviews" :key="index" :review="item" :user="user"
                @markModerate="markModerate" @deleteEntity="deleteEntity">
        </Review>
      </div>
      <div v-else>
        <p>Пока никто не оставил отзыв по товару.</p>
      </div>
    </div>
    <div class="reviews__right-block">
      <div v-if="!formAddReviewShow">
        <div class="reviews__statistics">
          <div class="reviews__statistics-data">
            <p>{{ statistics.rating }} / 5</p>
            <span v-for="n in 5" :class="[{ 'rating-active-star-icon': checkRating(n) }, 'rating-star-icon']"></span>
            <div>
            </div>
          </div>
          <div v-for="(item, index) in statistics.stars" :key="index" class="rating-value">
            <div class="rating-value__name">{{ ratingCode[item.code] }}</div>
            <div class="rating-value__line">
              <span class="rating-value__line-pct" :style="{ 'width': calculatePercentageRatings(item.value) }"></span>
            </div>
            <div>{{ item.value }}</div>
          </div>
        </div>
        <div class="reviews__button-block">
          <div v-if="user.authorizedUser">
            <button class="button-red" @click="openForm">Написать отзыв</button>
          </div>
          <div v-else>
            <p class="reviews__info">
              Для написания отзыва, вам необходимо
              <a @click="showAuth"> авторизоваться</a>.
            </p>
          </div>
        </div>
      </div>
      <div v-else class="reviews__form-wrap">
        <p class="reviews__form-title">Написать отзыв</p>
        <FormReviews @onSubmit="onSubmit" @closeForm="formAddReviewShow = false" :formShow="formAddReviewShow" :statusLoaded="statusLoaded"></FormReviews>
      </div>
    </div>
  </div>
</template>

<script>
// todo УДАЛИТЬ после получение данных с сервера
import reviewImg2 from '../assets/images/review-avatar.png';
import responseImg from '../assets/images/response-avatar.png';


import Review from "@/components/Review";
import axios from "axios";
import FormReviews from "@/components/FormReviews/FormReviews";
import eventBus from "@/js/eventBus";

export default {
  name      : "ListReviews",
  props     : {
    user       : {
      type   : Object,
      require: true
    },
    listReviews: {
      type   : Object,
      require: true
    },
    statistics : {
      type   : Object,
      require: false
    }
  },
  components: {FormReviews, Review},
  data() {
    return {
      // статические данные
      ratingCode       : {
        stars5: 'Отлично',
        stars4: 'Хорошо',
        stars3: 'Неплохо',
        stars2: 'Плохо',
        stars1: 'Ужасно'
      },
      formAddReviewShow: false,
      statusLoaded: false,
    }
  },
  methods: {
    showAuth() {
      $('#f__auth').modal('show');
    },
    calculatePercentageRatings(value) {
      let pct = 0;

      if (this.statistics.numberReviews) {
        pct = Math.round(value / this.statistics.numberReviews * 100)
      }

      return pct + '%';
    },
    checkRating(n) {
      return Math.round(this.statistics.rating - n) >= 0
    },
    printUserName(name, surname) {
      let value = surname ? surname.slice(0, 1) + '.' : ''
      return `${name} ${value}`
    },
    resetFrom() {
      this.formAddReview = {
        assessment   : null,
        review       : '',
        advantage    : '',
        disadvantages: '',
        comment      : '',
        anonymous    : false
      }
    },
    forumData() {
      return this.$parent.getForumData();
    },
    openForm() {
      this.formAddReviewShow = true;
    },
    onSubmit(formAddReview) {
      const formData = new FormData();

      formData.append('sessid', this.user.sessid);

      for (let key in formAddReview) {
        if(Array.isArray(formAddReview[key])) {
          for(let i = 0; i <= formAddReview[key].length - 1; i++) {
            formData.append(`${key}[${i}]`, formAddReview[key][i]);
          }
        } else {
          formData.append(key, formAddReview[key]);
        }
      }
      const forumData = this.forumData();

      formData.append('product_id', forumData.product_id);

      const that = this;
      that.statusLoaded = true;

      axios
          .post(
              '/api/forum/v1/reviews/',
              formData, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                }
              })
          .then(response => {
            const result = response.data;

            eventBus.$emit('info', response.data.message);

            if (result) {
              that.statusLoaded = false;
              that.resetFrom();
              that.formAddReviewShow = false;
              // обновить список отзывов
              that.$emit('loadReviews');
            }
          });
    },
    updateReviews(){
      this.$emit('loadReviews');
    },
    markModerate(uuid) {
      this.$emit('markModerate', uuid);
    },
    deleteEntity(uuid) {
      this.statusLoaded = true;
      this.$emit('deleteEntity', uuid);
      this.statusLoaded = false;
    }
  }
}
</script>

<style lang="scss">

</style>